import { EcomComponentWrapper } from './ecom_component_wrapper';

export default EcomComponentWrapper;
